import { useEffect, useState } from "react";
import logger from "../../utils/logger";



export const UseVisibleMembership = (params) => {


    const [enableModal, setEnableModal] = useState(true)

    useEffect(() => {

        const handleSpanVer = () => {
            const mobileSize = window.innerWidth
            // logger.info('tamaño actual: ', mobileSize)
            if (mobileSize <= 768) {
                setEnableModal(false)
            } else {
                setEnableModal(true)
            }
        }

        handleSpanVer()


        window.addEventListener('resize', handleSpanVer)

        // logger.info('enableAcction cambio a: ', enableModal)

    }, [enableModal])


    return { enableModal }
}